export const JWM_FIELD_MUTATION_SUBSCRIPTION = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;
